import { useState, useMemo } from 'react';
import type { PrintfulCatalogProduct } from '@stamp/merch';
import { MOCK_PRINTFUL_PRODUCTS, MOCK_VARIANTS } from '../api';

interface ProductSelectorProps {
  selectedIds: number[];
  onChange: (ids: number[]) => void;
  compatibleTechniques?: string[];
}

export function ProductSelector({ selectedIds, onChange, compatibleTechniques }: ProductSelectorProps) {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    let products = MOCK_PRINTFUL_PRODUCTS;
    if (compatibleTechniques && compatibleTechniques.length > 0) {
      // Filter products that have at least one matching technique
      // For mock, we don't filter since mock products are simplified
    }
    if (search) {
      const q = search.toLowerCase();
      products = products.filter(
        (p) => p.model.toLowerCase().includes(q) || p.brand.toLowerCase().includes(q) || p.type.toLowerCase().includes(q),
      );
    }
    return products;
  }, [search, compatibleTechniques]);

  function toggle(id: number) {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((x) => x !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  }

  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <input
          className="form-input"
          placeholder="Search Printful catalog..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="product-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))' }}>
        {filtered.map((p: PrintfulCatalogProduct) => {
          const selected = selectedIds.includes(p.id);
          const variantCount = MOCK_VARIANTS.filter((v) => v.product_id === p.id).length;
          return (
            <div
              key={p.id}
              className={`product-card ${selected ? 'candidate-card--selected' : ''}`}
              onClick={() => toggle(p.id)}
              style={{ cursor: 'pointer', border: selected ? '2px solid var(--gold)' : undefined }}
            >
              <img className="product-card__image" src={p.image} alt={p.model} />
              <div className="product-card__body">
                <div className="product-card__name" style={{ fontSize: '0.82rem' }}>{p.model}</div>
                <div className="product-card__brand">{p.brand}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px', fontSize: '0.72rem', color: 'var(--ink-faint)' }}>
                  <span>{p.type}</span>
                  <span>{variantCount || p.variant_count} variants</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {selectedIds.length > 0 && (
        <div style={{ marginTop: '12px', fontSize: '0.8rem', color: 'var(--ink-muted)' }}>
          {selectedIds.length} product{selectedIds.length > 1 ? 's' : ''} selected
        </div>
      )}
    </div>
  );
}
